export const API_URL = "https://api.aibjbi.com/api";

export const IMG_URL = "https://api.aibjbi.com/";

export const API_URL_DEV = "https://api.aibjbi.com/api";

export const IMG_URL_DEV = "https://aibjbi.com";

export const ERR_MESSAGE = "Something went wrong, Please try again later.";

export const LOGIN_FIRST_MESSAGE = "Please Login!";

export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const DECIMAL_CHECK_REGEX = /^(\d+)?(?:\.\d{1,4})?$/;

export const MANDATORY_QUES = "This Question is Mandatory!";

export const REQUIRED_FIELD = "This Field is Mandatory!";

export const PERCENTAGE_EXCEED_ERR = "100% is the upper limit!";

export const ADDRESS_LINK = "https://maps.app.goo.gl/aFEAyabLsJpUdPuZ6";
